import { apiCall, ApiConfig } from '../../config/api'
import { TypeAsnSource } from '../../interfaces/Asn/TypeAsnSource'
import { getTypesAsnSourceAction } from '../actions/typeAsnSourceActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_TYPE_ASN_SOURCE } from '../types/typeAsnSourceActionsTypes'
import { DataGridElements } from '../../interfaces/index'

export function* getTypesAsnSourceASync() {
  try {
    const { status, data }: AxiosResponse<DataGridElements<TypeAsnSource>> =
      yield call(apiCall, 'GET', `${ApiConfig.TypeAsnSource}?pageSize=50`)
    if (status === 200) {
      yield put(getTypesAsnSourceAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypesAsnSourceAction([], serverError.message))
  }
}

export function* watchGetTypesAsnSourceASync() {
  yield takeEvery(GET_TYPE_ASN_SOURCE, getTypesAsnSourceASync)
}
